import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, EffectFade } from 'swiper/modules';
import { useState } from 'react';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

import SlideImage from './SlideImage'; // Asegúrate de que esta ruta sea correcta

export default function Hero() {
  const [activeSlide, setActiveSlide] = useState(0);
  
  const imagenes = [
    { 
      archivo: 'hero_banner_1.webp', 
      lugar: 'Salta, Argentina'
    },
    { 
      archivo: 'hero_banner_2.webp', 
      lugar: 'Playa del Carmen, Cancún Mexico'
    },
    { 
      archivo: 'hero_banner_3.webp', 
      lugar: 'Sevilla, España'
    },
    { 
      archivo: 'hero_banner_4.webp', 
      lugar: 'New York, Estados Unidos'
    },
    
    { 
      archivo: 'hero_banner_6.webp', 
      lugar: 'Barcelona, España'
    },
    { 
      archivo: 'hero_banner_7.webp', 
      lugar: 'Teulada, Alicante'
    }
    ,
    { 
      archivo: 'hero_banner_8.webp', 
      lugar: 'Valencia, España'
    },
    { 
      archivo: 'hero_banner_9.webp', 
      lugar: 'Tulum, México'
    }
    
  ];

  return (
    <section
      id="hero"
      aria-label="Sección principal con imágenes destacadas"
      className="scroll-mt-28 w-full h-auto flex flex-col-reverse lg:flex-row"
    >

      <div className="w-full lg:w-1/3 min-h-[180px] sm:min-h-[200px] lg:h-auto bg-[#B49A56] flex flex-col justify-center items-center px-4 sm:px-6 py-4 sm:py-6">
        <div className="w-full flex justify-center mb-4 lg:mb-8">
          <img
            src={`${process.env.PUBLIC_URL}/assets/logo_transparente.png`}
            alt="Logo Belu Tours"
            className="hidden lg:block w-48 sm:w-56 md:w-64" loading="lazy"
          />
        </div>
        <h2 className="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl animate-fadeUp text-center leading-tight">
          Experiencias únicas,<br />
          recuerdos inolvidables
        </h2>

        <p className="text-white text-xs sm:text-sm md:text-base lg:text-lg mt-4 sm:mt-6 text-center font-medium break-words px-2 leading-relaxed">
          {imagenes[activeSlide].lugar}
        </p>
      </div>

      <div className="w-full lg:w-2/3 h-[300px] sm:h-[400px] md:h-[500px] lg:h-[600px] overflow-hidden">
        <Swiper
          modules={[Autoplay, Pagination, EffectFade]}
          loop
          effect="fade"
          speed={2000} // 💡 Transición lenta de 2 segundos
          fadeEffect={{ crossFade: true }} // ✨ Suaviza el fade
          autoplay={{ delay: 8000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          onSlideChange={(swiper) => setActiveSlide(swiper.realIndex)}
          className="h-full"
        >
          {imagenes.map((imagen, index) => {
            const url = `${process.env.PUBLIC_URL}/assets/hero/${imagen.archivo}`;
            return (
              <SwiperSlide key={imagen.archivo}>
                <SlideImage
                  src={url}
                  fallback={`${process.env.PUBLIC_URL}/assets/placeholder.jpg`}
                  alt={`Imagen del slider ${index + 1}`}
                  eager={index === 0}
                  sizes="(min-width:1024px) 66vw, 100vw"
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
}
